import React from 'react'
import { GridColumn, GridRow, Table } from 'semantic-ui-react'
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'

import SwiperCore, { Navigation, Pagination } from 'swiper/core'

import 'swiper/swiper.min.css'
import { GazettalData, PlacenameDataTypeProp } from '../slice'

import './PlacenameTab.css'

// install Swiper modules
SwiperCore.use([Pagination, Navigation])

export default function PlacenameTab3({ placenameData }: PlacenameDataTypeProp) {
  function displayGazettalInfo() {
    return (
      <React.Fragment>
        <GridRow className="placenameDetailsL1Row">
          <GridColumn width={16} className="placenameDetailsFieldLabel">
            <p>Register & Gazettal information</p>
          </GridColumn>
        </GridRow>
        <Table collapsing={false} stackable={false} unstackable striped celled className={'place-details-table'}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Date</Table.HeaderCell>
              <Table.HeaderCell>Gazettal</Table.HeaderCell>
              <Table.HeaderCell>Comment</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {(placenameData.gazettal) &&
              <Table.Body>
                {
                  placenameData.gazettal.map((gazettaData: GazettalData) =>
                    <Table.Row key={gazettaData.id}>
                      <Table.Cell>{gazettaData.date}</Table.Cell>
                      <Table.Cell>{gazettaData.gazettal}</Table.Cell>
                      <Table.Cell>{gazettaData.comment}</Table.Cell>
                    </Table.Row>,
                  )
                }

              </Table.Body>}
        </Table>
      </React.Fragment>
    )
  }

  function displayValidPlacenameFields() {
    return (
      <React.Fragment>
        {displayGazettalInfo()}
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      {displayValidPlacenameFields()}
    </React.Fragment>
  )

}

